
document.addEventListener("DOMContentLoaded", () => {
  const detailsElements = document.querySelectorAll(".menu-drawer__menu > li > details");

  detailsElements.forEach((details) => {
    details.addEventListener("toggle", () => {
      if (details.open) {
        // Close all other open details
        detailsElements.forEach((other) => {
          if (other !== details) {
            other.removeAttribute("open");
          }
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-product-atc-wrapper').forEach(wrapper => {
    const atcBtn = wrapper.querySelector('.card-atc-btn');
    const sheet = wrapper.querySelector('.card-variant-sheet');
    const closeSheet = wrapper.querySelector('.close-sheet');
    const variantButtons = wrapper.querySelectorAll('.variant-option');
    const defaultForm = wrapper.querySelector('product-form form');

    function openSheet() {
      // Close any other open sheets first
      document.querySelectorAll('.card-variant-sheet.open').forEach(openSheet => {
        openSheet.classList.remove('open');
        openSheet.closest('.card-product-atc-wrapper')
          ?.querySelector('.card-atc-btn')
          ?.classList.remove('hidden');
      });

      atcBtn?.classList.add('hidden');
      sheet?.classList.add('open');
    }

    function closeSheetFn() {
      sheet?.classList.remove('open');
      atcBtn?.classList.remove('hidden');
    }

    atcBtn?.addEventListener('click', openSheet);
    closeSheet?.addEventListener('click', closeSheetFn);

    // Add to cart via variant buttons
    variantButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const selectedVariant = btn.dataset.variantId;
        if (!selectedVariant || !defaultForm) return;

        const hiddenVariantInput = defaultForm.querySelector('[name="id"]');
        if (hiddenVariantInput) hiddenVariantInput.value = selectedVariant;

        defaultForm.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        );

        closeSheetFn();
      });
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (sheet.classList.contains('open')) {
        const clickedInside = wrapper.contains(e.target);
        if (!clickedInside) {
          closeSheetFn();
        }
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.size-chart-wrapper');
  const closeBtn = popup?.querySelector('.close-size-chart');

  // Attach to all size chart buttons on page
  document.querySelectorAll('.size-chart-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      popup.classList.add('active');
    });
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      popup.classList.remove('active');
    });
  }

  // Close when clicking outside content
  popup?.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.classList.remove('active');
    }
  });
});






